<template>

  
  <!-- 点赞卡medal -->
  <div class="user_container">

    <!-- 积分禁用蒙版 -->
    <div v-if="isPointDisabled" class="point-disabled-overlay" @click.prevent @touchmove.prevent>
      <div class="mask-content">
        <div class="mask-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#dc2626"/>
          </svg>
        </div>
        <div class="mask-title">账号已禁用</div>
        <div class="mask-desc">您的账号已被管理员禁用，暂无法使用积分及相关功能。</div>
        <div class="mask-desc" style="margin-top: 16px; font-size: 24px;">如有疑问请联系人力资源部</div>
      </div>
    </div>

    <div
      class="top_content"
      v-if="activeIndex == 0"
      :style="{ height: showUserBadge ? 'calc(100vh - 67px)' : '100vh' }"
    >
      <div class="user_top1">
        <!-- 1. 顶部用户信息栏 -->
        <div class="headerTop">
          <img :src="user.icon" alt="" class="img1" />
          <div class="top_userinfo">
            <div class="nickname">
              Hi，{{ user.nickname }}
              <img
                v-if="newBadge?.iconId"
                :src="imgUrl + newBadge?.iconId"
                alt=""
                style="width: 28px; height: 26px; margin-right: 10px"
              />
            </div>
            <div class="department1">
              <div class="department-dep">{{ user.department }}</div>
              <div class="department-dep">
                获得{{ badgeNum ? badgeNum : 0 }}个徽章， 部门排名第{{
                  companyRank
                }}
              </div>
            </div>
          </div>
          <div class="icon_con">
            <div style="position: relative">
              <img
                src="@/assets/newMedal/home/3.png"
                alt=""
                style="width: 20px; height: 20px"
                @click="toNewsList"
              />
              <img
                v-if="listTwo1.length > 0"
                class="circle"
                src="@/assets/newsNotice/icon6.png"
                alt=""
                style="width: 10px; height: 10px"
              />
            </div>
            <div class="left_con" @click="toMy">排行榜</div>
          </div>
        </div>
        <!-- 积分信息 -->
        <div class="score_info">
          <div class="score_left">
            <span class="score_label">累计积分：</span>
            <span class="score_num">{{totalPoints || 0}}</span>
          </div>
          <div class="score_right" v-if="pointsHide == 1">
            <!-- <span class="score_tip">积分记录请到福利平台查询</span> -->
            <span @click="goShop" class="score_btn">
              <!-- <img src="@/assets/medal/quaquaka/point.png" class="score_btn_icon" /> -->
              查询积分使用记录
            </span>
          </div>
        </div>

        <!-- 2. 横向标签栏 -->
        <div class="tab_bar">
          <div class="tab_item" @click="toMedal('/mobile/medal/myBadgeList')">
            <img
              class="tab_item_img"
              src="@/assets/newMedal/home/荣誉墙.png"
              alt=""
            />
            <span class="tab_item_text">荣誉墙</span>
          </div>
          <div class="tab_item" @click="handleTime">
            <img
              class="tab_item_img"
              src="@/assets/newMedal/home/时光加冕.png"
              alt=""
            />
            <span class="tab_item_text">时光加冕</span>
          </div>
          <!-- <div class="tab_item" @click="toMedal('/mobile/medal/publicWelfare')">
            <img
              class="tab_item_img"
              src="@/assets/newMedal/home/nvc_charity.png"
              alt=""
            />
            <span class="tab_item_text">雷士公益</span>
          </div> -->
          <div class="tab_item" @click="handleHistory">
            <img
              class="tab_item_img"
              src="@/assets/newMedal/home/荣誉记录.png"
              alt=""
            />
            <span class="tab_item_text">荣誉记录</span>
          </div>
          <div class="tab_item" @click="goShop" v-if="pointsHide == 1">
            <img
              class="tab_item_img"
              src="@/assets/newMedal/home/兑换.png"
              alt=""
            />
            <span class="tab_item_text">兑换礼品</span>
          </div>
        </div>

        <!-- 3. 点赞卡广场 -->
        <div class="kuakuaka_plaza">
          <div class="plaza_title">点赞广场</div>
          <!-- 可赠送点赞卡卡片 -->
          <div class="kuakuaka_card" @click="handleKuakuaka(1)">
            <img
              class="card_bg"
              src="@/assets/medal/quaquaka/background2.png"
              alt=""
            />
            <div class="card_top">
              <div class="card_title">点赞卡</div>
              <div class="card_score">{{sendTotal}}张</div>
            </div>
            <div class="card_btn_wrap">
              <div class="card_btn">点赞</div>
            </div>
          </div>
          <!-- 跑马灯轮播容器 -->
          <div class="marquee_box" v-if="likeList.length > 0">
            <div class="marquee_wrap" ref="marqueeWrap">
              <div class="marquee_list" ref="marqueeList">
                <div
                  class="feed_item"
                  v-for="(item, index) in likeList"
                  :key="index"
                >
                  <img :src="item.avatar" class="feed_avatar" alt="" />
                  <div>
                    <div class="feed_name">
                      {{ item.sendername }}送{{ item.receivername }}点赞卡
                    </div>

                    <div class="feed_bubble">
                      {{ item.reason || "感谢支持" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

   
        </div>

        <!-- 4. 排行榜模块 -->
        <div class="rank_top3" v-if="topList.length > 0">
          <div class="rank_top3_box_title">排行榜</div>
          <div class="rank_top3_box" @click.stop="toMy">
            <!-- 第2名 -->
            <div
              class="rank_card card2"
              @click="handleToBadgeList(topList[1] || {})"
            >
              <div class="rank_num_wrap" v-if="topList[1]?.nickName">
                <div class="rank_num">2</div>
              </div>

              <div class="avatar_box" v-if="topList[1]?.nickName">
                <img class="avatar" :src="topList[1]?.icon" alt="" />
              </div>

              <div class="num" v-if="topList[1]?.nickName">
                {{ topList[1]?.medalNumber }}枚
              </div>
              <div class="name" v-if="topList[1]?.nickName">
                {{ topList[1]?.nickName }}
              </div>
              <div class="dept" v-if="topList[1]?.nickName">
                {{ topList[1]?.departmentName }}
              </div>
            </div>

            <!-- 第1名 -->
            <div
              class="rank_card card1"
              @click="handleToBadgeList(topList[0] || {})"
            >
              <div class="rank_num_wrap" v-if="topList[0]?.nickName">
                <div class="rank_num">1</div>
              </div>

              <div class="avatar_box" v-if="topList[0]?.nickName">
                <img class="crown" src="@/assets/newMedal/bg14.png" alt="" />
                <img class="avatar" :src="topList[0]?.icon" alt="" />
              </div>

              <div class="num" v-if="topList[0]?.nickName">
                {{ topList[0]?.medalNumber }}枚
              </div>
              <div class="name" v-if="topList[0]?.nickName">
                {{ topList[0]?.nickName }}
              </div>
              <div class="dept" v-if="topList[0]?.nickName">
                {{ topList[0]?.departmentName }}
              </div>
            </div>

            <!-- 第3名 -->
            <div
              class="rank_card card3"
              @click="handleToBadgeList(topList[2] || {})"
            >
              <div class="rank_num_wrap" v-if="topList[2]?.nickName">
                <div class="rank_num">3</div>
              </div>

              <div class="avatar_box" v-if="topList[2]?.nickName">
                <img class="avatar" :src="topList[2]?.icon" alt="" />
              </div>

              <div class="num" v-if="topList[2]?.nickName">
                {{ topList[2]?.medalNumber }}枚
              </div>
              <div class="name" v-if="topList[2]?.nickName">
                {{ topList[2]?.nickName }}
              </div>
              <div class="dept" v-if="topList[2]?.nickName">
                {{ topList[2]?.departmentName }}
              </div>
            </div>
          </div>
        </div>
        <div class="contentCon" v-if="isShow">
          <div class="title">更多</div>
          <div class="content">
            <!-- 管理后台 -->
            <img
              @click="toMedal('/medal/badgeCategory')"
              style="width: 100%; height: 100%"
              src="@/assets/newMedal/home/14.svg"
              alt=""
            />
          </div>
        </div>
        <!-- 原有隐藏布局原样保留 -->
        <!-- <div style="display: none">
          <div class="headerTitle" @click="toRank">
            <span
              >获得<span style="color: #1bba84">{{
                badgeNum ? badgeNum : 0
              }}</span
              >个徽章，</span
            >
            部门排名<span style="color: #1bba84">{{ companyRank }}</span
             >位
          </div>
          <div class="swiper_con">
            <swiper
              v-if="pageShowList.length > 0"
              class="scrollItem"
              :options="optionsSwiper"
              style="width: 100%"
            >
              <swiper-slide
                v-for="(i, index) in pageShowList"
                :key="index"
                style="width: 100%"
              >
                <div class="slide_item" @click="handleSwiper(i)">
                  <img
                    src="@/assets/newMedal/home/2.svg"
                    alt=""
                    style="width: 18px; height: 18px"
                  />
                  <div class="name">
                    {{ i.sendername }}赠送一张{{
                      i.cardType == 1
                        ? "点赞卡"
                        : i.cardType == 2
                        ? "勋章卡"
                        : i.cardType == 3
                        ? "周年卡"
                        : ""
                    }}给您，请悉知
                  </div>
                  <img
                    src="@/assets/newMedal/home/5.svg"
                    alt=""
                    style="width: 18px; height: 18px"
                  />
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="contentCon">
            <div class="title">即时认可</div>
            <div class="content">
              <div class="left" style="position: relative">
                <img
                  @click="handleKuakuaka(1)"
                  src="@/assets/newMedal/home/6.svg"
                  alt=""
                />
                <div
                  style="
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: 100%;
                    background: rgb(0, 0, 0, 0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 20px;
                    border-radius: 18px;
                    color: #fff;
                    font-weight: bold;
                  "
                  @click="noHandle"
                  v-if="$store.state.userInfo.rtitle == 'O1'"
                ></div>
              </div>
              <div class="right">
                 我相关的 -
                <img
                  @click="handleKuakuaka(2)"
                  src="@/assets/newMedal/home/7.svg"
                  alt=""
                />
                我收到的 
                <img
                  @click="handleKuakuaka(3)"
                  style="margin-top: 8%"
                  src="@/assets/newMedal/home/8.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="contentCon">
            <div class="title">公司表彰</div>
            <div class="content">
              <div class="left">
                <img
                  @click="handleMedal"
                  src="@/assets/newMedal/home/9.svg"
                  alt=""
                />
                <img
                  @click="handleHistory"
                  style="margin-top: 8%"
                  src="@/assets/newMedal/home/10.svg"
                  alt=""
                />
                <img
                  @click="toMedal('/mobile/medal/myBadgeList')"
                  style="margin-top: 8%"
                  src="@/assets/newMedal/home/17.svg"
                  alt=""
                />
              </div>
              <div class="right">
                <img
                  @click="handleHis"
                  src="@/assets/newMedal/home/11.svg"
                  alt=""
                />
                <img
                  @click="handleTime"
                  style="margin-top: 8%"
                  src="@/assets/newMedal/home/13.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="contentCon" v-if="showPublicWelfare">
            <div class="title">公益慈善管理平台</div>
            <div class="content">
              <img
                @click="toMedal('/mobile/medal/publicWelfare')"
                style="width: 100%; height: 100%"
                src="@/assets/newMedal/home/18.svg"
                alt=""
              />
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div
      class="top_content"
      v-else
      :style="{ height: showUserBadge ? 'calc(100vh - 67px)' : '100vh' }"
    >
      <my></my>
    </div>

    <!-- 底部导航 -->
    <div class="footer_con" v-if="showUserBadge">
      <div
        class="footer_item"
        v-for="(item, index) in footerList"
        :key="index"
        @click="chandleFooter(item, index)"
      >
        <img :src="item.icon" alt="" style="width: 24px; height: 24px" />
        <div :class="activeIndex == index ? 'activeLabel' : 'label'">
          {{ item.label }}
        </div>
      </div>
    </div>

    <!-- 勋章弹窗：按 cardType 展示不同内容。样式统一复用原 scoped class，只整理结构 -->
    <div class="dialog_con" v-if="showBadge">
      <!-- ========== 共享区（所有卡都有） ========== -->
      <!-- 背景图（每种卡一套设计稿） -->
      <div :class="dialogBgClass"></div>

      <!-- 顶部标签：medalTypeName -->
      <div class="top_center">{{ itemInfo?.medalTypeName }}</div>

      <!-- 中间那枚大徽章（样式按 cardType 切换大小/位置） -->
      <div class="dialog_content">
        <div class="img_con">
          <img
            :class="badgeImgClass"
            :src="imgUrl + itemInfo?.iconId"
            alt=""
          />
        </div>
      </div>

      <!-- 底部关闭按钮 + logo -->
      <div class="cha_con" @click="closeDialog">
        <img
          @click="closeDialog"
          class="chaImg"
          src="@/assets/newsNotice/cha1.png"
          alt=""
        />
      </div>
      <div class="logo">
        <img src="@/assets/newMedal/time/logo.svg" alt="" />
      </div>

      <!-- 按钮（样式按 cardType 切换配色） -->
      <div :class="btnClass">
        <el-button @click="handleCheckDetail">查看详情</el-button>
      </div>

      <!-- 点亮日期（公益卡无此字段） -->
      <div class="date" v-if="itemInfo?.cardType != 4">
        于{{ itemInfo?.createDateFormat }}点亮勋章
      </div>

      <!-- ========== cardType 2：勋章卡（项目获奖，头部有用户信息 + 文案区） ========== -->
      <template v-if="itemInfo?.cardType == 2">
        <div class="info_left">
          <img :src="$store.state.userInfo.icon" alt="" />
          <div class="info_base">
            <div>{{ $store.state.userInfo.nickname }}</div>
            <div>{{ $store.state.userInfo.position }}</div>
          </div>
        </div>
        <div class="info_right">
          <div class="info_right_num"><span>1</span>枚</div>
          <div class="info_right_text">荣誉勋章</div>
        </div>
        <div class="info_buttom">
          <h2 class="buttom_title">{{ itemInfo?.title }}</h2>
          <p class="buttom_Con">
            恭喜您！您所参与的「{{ itemInfo?.title }}」项目，<br />荣耀加冕，荣获了「{{ itemInfo?.medalName }}」！
          </p>
        </div>
      </template>

      <!-- ========== cardType 1：点赞卡（简单获奖文案） ========== -->
      <template v-if="itemInfo?.cardType == 1">
        <div class="title">恭喜您</div>
        <div class="content_label">
          荣获<span>【{{ itemInfo?.medalName }}】</span>勋章
        </div>
      </template>

      <!-- ========== cardType 3：周年卡（时光加冕，中部有周年轮播徽章） ========== -->
      <template v-if="itemInfo?.cardType == 3">
        <div class="title_con">
          <div class="title1">{{ itemInfo?.medalName }}</div>
          <div class="title2">
            雷士照明与你相伴<span style="color: #00ff94">{{ itemInfo?.companyAge }}</span>时光
          </div>
        </div>
        <div class="badge_con">
          <div
            :class="`imgList${activeIndex1}`"
            v-for="(item, index) in badgeListData"
            :key="index"
          >
            <div :class="activeIndex1 == index ? 'imgOne' : ''">
              <img
                :class="`img${index}`"
                :src="imgUrl + (item.light == 1 ? item.iconId : item.fileId)"
                alt=""
              />
              <div class="name" v-if="activeIndex1 == index">
                {{ item?.medalName }}
              </div>
            </div>
          </div>
        </div>
      </template>

      <!-- ========== cardType 4：公益成就（有装饰图 + 公益文案，无日期） ========== -->
      <template v-if="itemInfo?.cardType == 4">
        <div class="info_left1">
          <img :src="$store.state.userInfo.icon" alt="" />
          <div class="info_base">
            <div>{{ $store.state.userInfo.nickname }}</div>
            <div>{{ $store.state.userInfo.position }}</div>
          </div>
        </div>
        <div class="title_con1">
          <img class="img_con" src="@/assets/newMedal/time/timeLeft.png" alt="" />
          <div class="title_name">{{ itemInfo?.medalName }}</div>
          <img class="img_con" src="@/assets/newMedal/time/timeRight.png" alt="" />
        </div>
        <div class="remark_con">
          <div class="top_con">雷士公益成就{{ itemInfo?.unlockDuration }}小时勋章</div>
          <div class="buttom_con">
            解锁：<span style="color: #22ba98">1</span>枚
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import api from "@/apis/medal";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import my from "./my.vue";
import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
import utils from "@/utils/utils";

export default {
  name: "facility",
  props: {},
  components: {
    swiper,
    swiperSlide,
    my,
  },
  data() {
    return {
      list: [
        {
          name: "历史记录",
          img: require("@/assets/newsNotice/lishijilu.png"),
          path: `/mobile/medal/infoDetail?isHR=${this.$store.state.userInfo.hr}`,
          isActive: true,
          isShow: true,
        },
        {
          name: "我的历程",
          img: require("@/assets/newsNotice/wodelicheng.png"),
          path: "/mobile/medal",
          isActive: true,
          isShow: true,
        },
        {
          name: "荣誉墙",
          img: require("@/assets/newsNotice/rongyu.png"),
          path: "/mobile/medal/myBadgeList",
          isActive: true,
          isShow: true,
        },
        {
          name: "徽章类别配置",
          img: require("@/assets/newsNotice/huizhangleibie.png"),
          path: "/medal/badgeCategory",
          isShow: true,
        },
      ],
      footerList: [
        {
          icon: require("@/assets/newMedal/home/15.svg"),
          activeIcon: require("@/assets/newsNotice/activeHome.png"),
          label: "首页",
        },
        {
          icon: require("@/assets/newMedal/home/16.svg"),
          activeIcon: require("@/assets/newsNotice/activeMy.png"),
          label: "我的",
        },
      ],
      user: {},
      nums: "",
      total: "",
      isShow: false,
      activeIndex: 0,
      pageShowList: [],
      showBadge: false,
      imgUrl: "",
      itemInfo: {},
      listTwo1: [],
      showUserBadge: true,
      companyRank: null,
      badgeNum: null,
      newBadge: {},
      optionsSwiper: {
        autoHeight: true,
        autoplay: {
          disableOnInteraction: false,
          delay: "5000",
          observer: true,
          observeParents: true,
        },
      },
      badgeListData: [],
      activeIndex1: 0,
      showPublicWelfare: true,
      likeList: [], // 点赞卡广场列表
      marqueeTimer: null, // 跑马灯定时器
      marqueeSpeed: 1, // 滚动速度（越大越快）
      topList: [], // 前三名排行榜数据
      pointsShopUrl: "",
      pointsHide: 1,
      sendTotal: 0, //可赠送次数总和
      isPointDisabled: false, // 积分是否被禁用
      totalPoints: 0, // 总积分数
    };
  },
  // 勋章弹窗计算属性：把嵌套三元集中管理，方便维护
  computed: {
    // 弹窗背景图 class（按 cardType 切换不同设计稿背景）
    dialogBgClass() {
      const map = {
        1: "dialog_img_con2", // 点赞卡
        2: "dialog_img_con3", // 勋章卡
        3: "dialog_img_con4", // 周年卡
        4: "dialog_img_con5", // 公益成就
      };
      return map[this.itemInfo?.cardType] || "dialog_img_con";
    },
    // 弹窗按钮样式 class（每种卡有独立按钮设计）
    btnClass() {
      const map = {
        1: "btn_con",
        2: "btn_con1",
        3: "btn_con2",
        4: "btn_con3",
      };
      return map[this.itemInfo?.cardType] || "btn_con";
    },
    // 中间那枚大徽章的图片样式（不同卡种大小/位置不同）
    badgeImgClass() {
      const map = {
        2: "badgeImg1",
        4: "badgeImg2",
      };
      return map[this.itemInfo?.cardType] || "badgeImg";
    },
  },
  created() {
    this.user = this.$store.state.userInfo;
    this.isShow =
      this.$store.state.userInfo.hr == 1 ||
      this.$store.state.userInfo.username == "10005038" ||
      this.$store.state.userInfo.username == "10008797"
        ? utils.parseUA().mobile
          ? false
          : true
        : false;
    this.giveLikeList();
    this.getHomeTop3(); // 获取首页前三名
    this.getBaseData();
    this.getSendTotal();
  },
  mounted() {
    this.imgUrl = api.imgUrl;
    localStorage.removeItem("tabValue");
    let hrToken = getToken();
    if (hrToken) {
      this.queryMyBadge(hrToken);
      this.getBadgeListTwo(hrToken);
      this.getInfo1(hrToken);
      this.medalCardNewReceived(hrToken);
      this.checkUserPointStatus(); // 检查用户积分状态
    } else {
      this.$bus.$on("processToken", (res) => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.queryMyBadge(res);
          this.getBadgeListTwo(res);
          this.getInfo1(res);
          this.medalCardNewReceived(res);
          this.checkUserPointStatus(); // 检查用户积分状态
        });
      });
    }
  },
  watch: {
    // 监听底部导航切换
    activeIndex(newVal) {
      // 切回首页时，重新启动跑马灯
      if (newVal == 0) {
        this.$nextTick(() => {
          this.startMarquee();
        });
      } else {
        // 切走时清除定时器，防止报错
        this.clearMarquee();
      }
    },
    // 监听积分禁用状态，控制页面滚动
    isPointDisabled(val) {
      if (val) {
        // 禁用页面滚动
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        // 恢复页面滚动
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
      }
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem("isShowBadge");
    this.clearMarquee(); // 清除跑马灯
    // 组件销毁时恢复页面滚动
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
  },
  methods: {
    // 检查用户积分状态
    checkUserPointStatus() {
      api
        .getPointMgn({
          empNo: this.user.userid,
          page: 1,
          pageSize: 10,
        })
        .then((res) => {
          if (res.code == 200 && res.data?.list && res.data.list.length > 0) {
            const userInfo = res.data.list[0];
         
            this.totalPoints = userInfo.totalPoints || 0;
            if (userInfo.userPointStates == "1") {
              this.isPointDisabled = true;
            }
          }
        })
        .catch((err) => {
          console.error("检查用户积分状态失败:", err);
        });
    },
    getSendTotal() {
      // console.log("获取可赠送次数总和",this.user);
      api
        .medalCardLstApi({
          page: 1,
          pageSize: 2000,
          empno: this.user.userid,//工号
          hrAuthToken: window.sessionStorage.hrToken,
        })
        .then((res) => {
          console.log(res,'res');
          if (res.code == 200) {
            this.sendTotal = res.data?.length ||  0;
          }
        });
    },

    goShop() {
      if (this.pointsShopUrl) {
        window.open(this.pointsShopUrl, "_blank");
      } else {
        this.$message.warning("积分商城未配置");
        return;
      }
    },
    // 获取积分商城基础配置
    getBaseData() {
      this.pageLoading = true;

      try {
        api.getPointBaseSet({ page: 1, pageSize: 1 }).then((res) => {
          const data = res.data?.list?.[0] || {};
          if (data) {
            this.pointsShopUrl = data.mallUrl;
            this.pointsHide = data.isHide;
          }
        });
      } catch (err) {
        this.pageLoading = false;

        this.$message.error("获取基础配置失败");
      }
    },
    // 获取首页前三名排行榜
    getHomeTop3() {
      let departmentCode = this.$store.state.userInfo.departmentCode.slice(
        0,
        3
      );
      api
        .queryRankingList({
          departmentCode: departmentCode,
          page: 1,
          pageSize: 20,
        })
        .then((res) => {
          if (res.code == 200) {
            this.topList = res.data.top || [];
          }
        });
    }, // 点赞卡广场 垂直跑马灯
    startMarquee() {
      const wrap = this.$refs.marqueeWrap;
      const list = this.$refs.marqueeList;
      if (!wrap || !list || this.likeList.length === 0) return;

      // 复制一份内容实现无缝滚动
      list.innerHTML += list.innerHTML;

      let scrollTop = 0;
      this.marqueeTimer = setInterval(() => {
        scrollTop += this.marqueeSpeed;
        // 滚动到一半重置 = 无缝循环
        if (scrollTop >= list.offsetHeight / 2) {
          scrollTop = 0;
        }
        wrap.scrollTop = scrollTop;
      }, 30);
    },

    // 清除定时器
    clearMarquee() {
      if (this.marqueeTimer) {
        clearInterval(this.marqueeTimer);
        this.marqueeTimer = null;
      }
    },
    // 点赞卡点赞广场列表
    giveLikeList() {
      let params = {
        page: 1,
        pageSize: 100,
        likeStatus: 1,
        // username: this.$store.state.userInfo.username,
        cardType: 1,
      };
      api.giveLikeList(params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.likeList = res.data?.list || [];
          // DOM 渲染完启动跑马灯
          this.$nextTick(() => {
            this.startMarquee();
          });
        }
      });
    },
    getHrToken(username) {
      return new Promise((resolve) => {
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }
          apiLogin.getUserToken({ username: thisname }).then((data) => {
            const info = data.data;
            localStorage.setItem("salaryPhone", info.mobileNo);
            localStorage.setItem("salaryInfo", JSON.stringify(info));
            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    toMedal(item) {
      this.$router.push(item);
    },
    toUrl() {
      this.$router.push("/mobile/medal/quaquaka");
      localStorage.setItem("quaActive", 1);
    },
    toBadge() {
      localStorage.setItem("tabsActive", 2);
      this.$router.push(`/mobile/medal/quaquaka`);
    },
    handleHistory() {
      this.$router.push(
        `/mobile/medal/infoDetail?isHR=${this.$store.state.userInfo.hr}`
      );
    },
    handleHis() {
      this.$router.push(`/mobile/medal/newsNotice/history`);
    },
    handleTime() {
      this.$router.push(`/mobile/medal/timeCoronation1`);
    },
    handleKuakuaka(type) {
      localStorage.removeItem("quaActive");
      localStorage.setItem("tabsActive", 1);
      this.$router.push(`/mobile/medal/quaquaka?type=${type}`);
    },
    noHandle() {
      this.$message({
        type: "error",
        message: "暂无赠送点赞卡权限",
        duration: 2000,
      });
    },
    handleMedal() {
      this.$router.push(`/mobile/medal/publish`);
    },
    // 底部我的和首页切换
    chandleFooter(item, index) {
      this.activeIndex = index;
    },
    handleSwiper(item) {
      if (item.receiverEmpno == getToken()) {
        if (item.type == 1) {
          this.showBadge = true;
          this.itemInfo = item;
          this.activeIndex1 = this.badgeListData.findIndex(
            (item) =>
              this.itemInfo.cardType == 3 &&
              this.itemInfo.companyAge === item.companyAge
          );
        } else {
          this.$router.push({
            path: "/mobile/medal/quaquakaDetail",
            query: {
              id: item.id,
            },
          });
        }
      }
    },
    toNewsList() {
      this.$router.push("/mobile/medal/newsList");
    },
    toMy() {
      this.$router.push("/mobile/medal/rankList");
    },
    closeDialog() {
      this.showBadge = false;
    },
    getUnReadRecords(empno) {
      api
        .getUnReadRecordsApi({
          empno,
          hrAuthToken: window.sessionStorage.hrToken,
          channel: this.$route.query.id ? 1 : 2,
        })
        .then((res) => {
          if (res.code == 200) {
            this.pageShowList = res.data;
            if (this.$route.query.id) {
              const info = this.pageShowList.filter(
                (item) => item.id == this.$route.query.id
              );
              if (info.length > 0) {
                this.itemInfo = info[0];
                this.activeIndex1 = this.badgeListData.findIndex(
                  (item) =>
                    this.itemInfo.cardType == 3 &&
                    this.itemInfo.companyAge == item.companyAge
                );
                if (this.itemInfo.receiverEmpno == getToken()) {
                  this.showBadge = true;
                }
              } else {
                if (
                  !(sessionStorage.getItem("isShowBadge") == "true") ||
                  !sessionStorage.getItem("isShowBadge")
                ) {
                  this.getBadgeDetail();
                }
              }
            } else {
              if (this.pageShowList.length > 0) {
                this.itemInfo = this.pageShowList[0];
                this.activeIndex1 = this.badgeListData.findIndex(
                  (item) =>
                    this.itemInfo.cardType == 3 &&
                    this.itemInfo.companyAge === item.companyAge
                );
                if (this.itemInfo.receiverEmpno == getToken()) {
                  this.showBadge = true;
                }
              }
            }
          }
        });
    },
    handleCheckDetail() {
      const id = this.$route.query.id;
      if (this.itemInfo?.cardType == 1) {
        this.$router.push({
          path: "/mobile/medal/quaquakaDetail",
          query: {
            id: this.itemInfo?.id,
            value: id ? 1 : 2,
          },
        });
      }
      if (this.itemInfo?.cardType == 3) {
        this.$router.push({
          path: "/mobile/medal/badgeDetail",
          query: {
            id: this.itemInfo?.id,
            value: id ? 1 : 2,
          },
        });
      }
      if (this.itemInfo?.cardType == 2) {
        this.$router.push({
          path: "/mobile/medal/newsNotice/medalDetail",
          query: {
            id: this.itemInfo?.id,
            value: id ? 1 : 2,
          },
        });
      }
      if (this.itemInfo?.cardType == 4) {
        this.$router.push({
          path: "/mobile/medal/publicWelfare/benefitDetail",
          query: {
            id: this.itemInfo?.id,
            value: id ? 1 : 2,
          },
        });
      }
    },
    handleCheckPublicBenefit() {
      this.$router.push({
        path: "/mobile/medal/publicWelfare/benefitDetail",
      });
    },
    getBadgeListTwo(empno) {
      api
        .medalCardRevApi({
          page: 1,
          pageSize: 20,
          recordType: "1",
          flagType: "1",
          empno,
          hrAuthToken: window.sessionStorage.hrToken,
        })
        .then((res) => {
          if (res.code == 200) {
            this.listTwo1 = res.data;
          }
        });
    },
    getInfo1(empno) {
      api
        .myRankingApi({ empno, hrAuthToken: window.sessionStorage.hrToken })
        .then((res) => {
          this.companyRank = res.data.levelOneDeptRank;
          this.badgeNum = res.data.grandTotal;
        });
    },
    medalCardNewReceived(token) {
      const json = {
        recordType: 1,
        empno: token,
      };
      api.medalCardNewReceivedApi(json).then((res) => {
        if (res.code == 200) {
          this.newBadge = res.data[0];
        }
      });
    },
    getBadgeDetail() {
      api
        .medalCardDetailApi({
          id: this.$route.query.id,
          empno: getToken(),
          channel: this.$route.query.id ? 1 : 2,
        })
        .catch((err) => {
          if (err.code === 0) {
            this.$message({
              type: "error",
              message: err.message,
              duration: 2000,
            });
          }
        });
    },
    queryMyBadge(token) {
      api
        .myBadgeApi({
          cardType: "",
          empno: token,
          id: "",
        })
        .then((res) => {
          if (res.code == 200) {
            const list = res.data.filter((item) => item.cardType == 3);
            this.badgeListData = list[0].medals.sort(
              (a, b) => a.companyAge - b.companyAge
            );
            this.getUnReadRecords(token);
          }
        });
    },
    toRank() {
      this.$router.push({
        path: "/mobile/medal/rankList",
        query: {
          newValue: this.$store.state.userInfo.departmentCode.slice(0, 3),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
$color-primary: #1bba84;
$color-bg-light: #e6f7ef;
$color-text-main: #121826;
$color-text-secondary: #6c727f;
$color-text-gray: #666;
$radius-normal: 12px;
$radius-large: 16px;

// 基础容器适配
@media screen and (max-width: 600px) {
  .user_container,
  .dialog_con {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container,
  .dialog_con {
    width: 276px * $zoom;
  }
}

// 主容器
.user_container {
  min-height: 100vh;
  margin: 0 auto;
  font-size: 1vh;
  background-color: #fff;
  overflow: hidden;
  position: relative;

  // 通用工具类
  .flex {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  // 顶部内容区
  .top_content {
    background: linear-gradient(180deg, #f0f9f5 0%, #e2f3ee 100%);
    // background: linear-gradient(180deg, $color-bg-light 0%, #deeae6 100%);
    background-size: cover;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  // 底部导航
  .footer_con {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 120px;
    width: 100%;
    background-color: #fff;
    font-size: 28px;

    .footer_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;

      .label {
        font-weight: 400;
        color: #bfbfbf;
        font-size: 22px;
      }
      .activeLabel {
        font-weight: 500;
        color: #303030;
        font-size: 22px;
      }
    }
  }

  // 顶部用户信息区
  .user_top1 {
    padding-bottom: 40px;

    .headerTop {
      display: flex;
      align-items: center;
      padding: 60px 30px 0 40px;
      gap: 20px;

      .img1 {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        object-fit: cover;
      }

      .top_userinfo {
        flex: 1;

        .nickname {
          font-size: 31px;
          color: $color-text-main;
          font-weight: 600;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .department1 {
          font-size: 24px;
          color: $color-text-secondary;
          .department-dep {
            margin-bottom: 10px;
          }
        }
      }

      .icon_con {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        position: relative;

        .left_con {
          background: $color-primary;
          color: #fff;
          padding: 4px 20px;
          border-radius: 12px;
          font-size: 20px;
          text-align: center;
          white-space: nowrap;
        }
        .circle {
          position: absolute;
          top: 0;
          right: -6px;
        }
      }
    }

    // 积分栏
    .score_info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: nowrap;
      gap: 12px;
      box-sizing: border-box;
      margin: 20px 30px 0 30px;
      padding: 20px 0;
      font-size: 24px;
      line-height: 1;
      border-bottom: 1px solid #f0f0f0;

      .score_left {
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        height: 40px;
        line-height: 1;

        .score_label,
        .score_num {
          display: inline-flex;
          align-items: center;
          height: 100%;
          line-height: 1;
          white-space: nowrap;
        }

        .score_label {
          font-size: 28px;
          color: #333;
        }

        .score_num {
          font-size: 32px;
          font-weight: bold;
          color: #333;
        }
      }

      .score_right {
        display: flex;
        flex: 1 1 auto;
        align-items: center;
        justify-content: flex-end;
        min-width: 0;
        height: 40px;
        line-height: 1;

        .score_tip {
          display: inline-flex;
          align-items: center;
          height: 100%;
          font-size: 24px;
          line-height: 1;
          color: #999;
          white-space: nowrap;
        }

        .score_btn {
          display: inline-flex;
          flex: 0 0 auto;
          align-items: center;
          height: 100%;
          margin-left: 12px;
          font-size: 24px;
          line-height: 1;
          color: $color-primary;
          white-space: nowrap;
          cursor: pointer;

          .score_btn_icon {
            display: block;
            flex: 0 0 auto;
            width: 32px;
            height: 32px;
            margin-right: 6px;
            object-fit: contain;
          }

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    // 标签栏
    .tab_bar {
      display: flex;
      justify-content: space-around;
      padding: 20px 30px;
      background-color: #fff;
      margin: 30px 20px 20px;
      border-radius: $radius-large;

      .tab_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;

        .tab_item_img {
          width: 50px;
          height: 50px;
        }
        .tab_item_text {
          font-size: 26px;
        }
      }
    }
    // ================== 点赞卡广场 跑马灯样式 ==================
    .kuakuaka_plaza {
      background: linear-gradient(
        145deg,
        #f0fdf4 0%,
        #ecfdf5 50%,
        #d1fae5 100%
      );
      margin: 30px 20px 20px;
      border-radius: 24px;
      padding: 24px;
      border: 2px solid #bbf7d0;
      box-shadow: 0 4px 20px rgba(34, 197, 94, 0.15),
        0 1px 3px rgba(20, 184, 166, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: -1px;
        left: 15%;
        right: 15%;
        height: 3px;
        background: linear-gradient(
          90deg,
          transparent,
          #86efac,
          #4ade80,
          #86efac,
          transparent
        );
        border-radius: 2px;
      }

      .plaza_title {
        font-size: 31px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
        // color: #166534;
        position: relative;
        padding-top: 10px;

        &::after {
          content: "";
          position: absolute;
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 3px;
          background: linear-gradient(90deg, #86efac, #22c55e);
          border-radius: 2px;
        }
      }

      // 跑马灯外层
      .marquee_box {
        width: 100%;
        height: 600px; /* 跑马灯显示高度 */
        overflow: hidden;
        position: relative;
        margin-bottom: 20px;
      }

      .marquee_wrap {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }

      .marquee_list {
        width: 100%;
      }

      // 单条消息样式
      .feed_item {
        display: flex;
        // align-items: center;
        margin-bottom: 24px;
        gap: 10px;
        padding: 0 5px;

        .feed_avatar {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          object-fit: cover;
          flex-shrink: 0;
        }
        .feed_name {
          font-size: 24px;
          color: #333;
          font-weight: 600;
          margin-bottom: 10px;
        }
        .feed_bubble {
          background: #fff;
          padding: 12px 18px;
          border-radius: 4px 18px 18px 18px;
          font-size: 24px;
          color: #1f2937;
          max-width: 100%;
          line-height: 1.5;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
          position: relative;

          &::before {
            content: "";
            position: absolute;
            top: 8px;
            left: -8px;
            width: 0;
            height: 0;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-right: 8px solid #dcfce7;
          }

          &::after {
            content: "";
            position: absolute;
            top: 9px;
            left: -6px;
            width: 0;
            height: 0;
            border-top: 7px solid transparent;
            border-bottom: 7px solid transparent;
            border-right: 7px solid #bbf7d0;
          }
        }
      }
      // 点赞卡卡片（保持不变，只做了轻微对齐优化）
      .kuakuaka_card {
        position: relative;
        width: 100%;
        height: 370px;
        border-radius: 20px;
        overflow: hidden;
        margin: 0 auto;
        cursor: pointer;

        .card_bg {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          object-fit: cover;
          z-index: 1;
        }

        .card_top {
          position: absolute;
          z-index: 2;
          top: 4%;
          left: 8%;
          right: 13%;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .card_title {
            font-weight: 800;
            font-size: 32px;
            color: #282b32;
          }
          .card_score {
            font-weight: 500;
            font-size: 24px;
            color: #1bb888;
          }
        }

        .card_btn_wrap {
          position: absolute;
          z-index: 2;
          top: 62%;
          left: 0;
          right: 0;
          display: flex;
          justify-content: center;

          .card_btn {
            width: 264px;
            height: 69px;
            border-radius: 30px;
            background: linear-gradient(333deg, #0aad82 0%, #61e69e 100%);
            color: #fff;
            font-size: 28px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
          }
        }
      }
    }
    // 点赞卡排行榜
    .rank_top3 {
      .rank_top3_box_title {
        font-size: 31px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 15px;
      }

      .rank_top3_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 80px;
        width: 100%;

        .rank_card {
          width: 33%;
          text-align: center;
          position: relative;
          cursor: pointer;

          // ========== 排名数字 圆形优化 ==========
          .rank_num_wrap {
            margin-bottom: 12px;
          }
          .rank_num {
            width: 46px;
            height: 46px;
            line-height: 46px;
            text-align: center;
            border-radius: 50%;
            font-size: 26px;
            font-weight: bold;
            color: #fff;
            margin: 0 auto;
            box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
          }

          // ========== 徽章枚数 美观优化 ==========
          .num {
            color: #ff5c5c;
            font-size: 28px;
            font-weight: 600;
            margin: 12px 0 16px;
          }

          .avatar_box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: auto;
            height: auto;
            border: none;
            border-radius: unset;
            overflow: visible;

            .avatar {
              width: 146px;
              height: 146px;
              border-radius: 50%;
              border: 6px solid #fff;
              object-fit: cover;
            }
          }

          .name {
            color: #191b20;
            font-size: 29px;
            margin: 0 0 10px;
            font-weight: 500;
          }
          .dept {
            color: #666666;
            font-size: 24px;
          }
        }

        // 第一名 金色
        .rank_card.card1 .rank_num {
          background: linear-gradient(135deg, #ffd700, #ffb300);
        }
        // 第二名 银色
        .rank_card.card2 .rank_num {
          background: linear-gradient(135deg, #c0c0c0, #a8a8a8);
        }
        // 第三名 铜色
        .rank_card.card3 .rank_num {
          background: linear-gradient(135deg, #cd7f32, #b86b20);
        }

        /* 偏移不变 */
        .rank_card.card2,
        .rank_card.card3 {
          margin-top: 120px;
        }
        .rank_card.card1 {
          margin-top: 0;
        }

        /* 第一名皇冠、大头像 */
        .rank_card.card1 .avatar_box {
          .crown {
            width: 85px;
            height: 45px;
            margin-bottom: -6px;
            position: relative;
            z-index: 1;
          }
          .avatar {
            width: 180px;
            height: 180px;
          }
        }
      }
    }
    // 旧版隐藏模块（保留不动）
    .headerTitle {
      font-size: 28px;
      color: $color-text-secondary;
      margin-top: 30px;
      padding-left: 40px;
    }
    .swiper_con {
      padding: 0 30px;
      .scrollItem {
        border-radius: 6px;
        margin-top: 50px;
      }
      .slide_item {
        display: flex;
        align-items: center;
        margin-left: 40px;
        color: $color-text-main;
        .name {
          margin-left: 10px;
          font-size: 28px;
          width: 82%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  // 旧菜单模块
  .contentCon {
    padding: 0 40px;
    .title {
      font-size: 31px;
      font-weight: bold;
      margin-left: 30px;
      margin-top: 25px;
    }
    .content {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 25px;
    }
    .left,
    .right {
      width: 48%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

// 积分禁用蒙版样式
.point-disabled-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  overflow: hidden;
  pointer-events: auto;
  margin: 0;
  padding: 0;
  border: none;

  .mask-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 85%;
    max-width: 480px;
    padding: 70px 50px;
    background: #ffffff;
    border-radius: 24px;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    text-align: center;
  }

  .mask-icon {
    margin-bottom: 30px;
    animation: maskShake 0.5s ease-in-out;
  }

  .mask-title {
    font-size: 36px;
    font-weight: 700;
    color: #dc2626;
    margin-bottom: 20px;
  }

  .mask-desc {
    font-size: 28px;
    color: #6b7280;
    line-height: 1.8;
  }
}

@keyframes maskShake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

// 弹窗样式（完全保留原逻辑，只整洁代码）
@keyframes floatAndFade {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}
.dialog_con {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  animation: floatAndFade 1s ease;

  .dialog_img_con,
  .dialog_img_con2,
  .dialog_img_con3,
  .dialog_img_con4,
  .dialog_img_con5 {
    width: 100%;
    height: 100vh;
    // 背景图按容器尺寸拉伸，保证图内元素与百分比定位的文字始终对齐
    background-repeat: no-repeat;
    background-size: 100% 100%;
    transition: height 0.1s linear;
  }
  .dialog_img_con {
    background-image: url("~@/assets/newMedal/bg9.png");
  }
  .dialog_img_con2 {
    background-image: url("~@/assets/newMedal/bg8.png");
  }
  .dialog_img_con3 {
    background-image: url("~@/assets/newMedal/bg7.png");
  }
  .dialog_img_con4 {
    background-image: url("~@/assets/newMedal/time/time1.png");
  }
  .dialog_img_con5 {
    background-image: url("~@/assets/newMedal/time/time3.png");
  }

  .top_center {
    position: absolute;
    top: 5%;
    width: 100%;
    text-align: center;
    font-size: 30px;
    color: #fff;
  }

  // 弹窗用户信息
  .info_left {
    display: flex;
    align-items: center;
    position: absolute;
    top: 15%;
    left: 6%;
    img {
      width: 95px;
      height: 95px;
      border: 10px solid #ba9069;
      border-radius: 50%;
    }
    .info_base {
      margin-left: 20px;
      color: #fff;
      font-size: 26px;
      div:first-child {
        color: #ffc974;
        font-size: 34px;
        font-weight: bold;
        margin-bottom: 15px;
      }
    }
  }

  .info_left1 {
    display: flex;
    align-items: center;
    position: absolute;
    top: 12%;
    left: 6%;
    img {
      width: 75px;
      height: 75px;
      border: 5px solid #fff;
      border-radius: 50%;
    }
    .info_base {
      margin-left: 20px;
      color: #fff;
      font-size: 26px;
      div:first-child {
        font-size: 29px;
        font-weight: bold;
        margin-bottom: 15px;
      }
      div:nth-child(2) {
        color: #999;
        font-size: 22px;
        font-weight: bold;
      }
    }
  }

  .info_right {
    position: absolute;
    top: 15%;
    right: 11.5%;
    color: #fff;
    .info_right_num {
      font-size: 26px;
      text-align: center;
      span {
        font-size: 66px;
        color: #ffc974;
        font-weight: bold;
      }
    }
    .info_right_text {
      font-size: 24px;
      text-align: center;
    }
  }

  .info_buttom {
    position: absolute;
    bottom: 32vh;
    left: 0;
    width: 100%;
    color: #fff;
    text-align: center;
    .buttom_title {
      font-size: 36px;
      padding: 0 40px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .buttom_Con {
      font-size: 26px;
    }
  }

  // 弹窗文本
  .title {
    position: absolute;
    top:55.5%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 32px;
    font-weight: bold;
    color: #272e3a;
  }
  .content_label {
    position: absolute;
    top: 68%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 34px;
    font-weight: bold;
    color: #fff;
    span {
      color: #f1e8c8;
    }
  }
  .date {
    position: absolute;
    top: 74%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 28px;
    color: #fff;
    white-space: nowrap;
  }

  // 弹窗按钮
  .btn_con,
  .btn_con1,
  .btn_con2,
  .btn_con3 {
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
  }
  .btn_con .el-button {
    width: 450px;
    height: 80px;
    background: linear-gradient(0deg, #ecca9b -17%, #f8f0d0 136%);
    border: none;
    border-radius: 100px;
    color: #272e3a;
    font-size: 30px;
    font-weight: bold;
  }
  .btn_con1 .el-button {
    width: 450px;
    height: 80px;
    background: linear-gradient(78deg, #b98f68 2%, #eec696 91%);
    border: none;
    border-radius: 100px;
    color: #391f06;
    font-size: 30px;
    font-weight: bold;
  }
  .btn_con2 ::v-deep .el-button {
    width: 400px;
    height: 80px;
    background: #008755;
    color: #fff;
    font-size: 36px;
    border-radius: 40px;
    border-color: #008755;
  }
  .btn_con3 ::v-deep .el-button {
    width: 400px;
    height: 80px;
    background: linear-gradient(333deg, #0aad82 0%, #61e69e 100%);
    color: #fff;
    font-size: 36px;
    border-radius: 40px;
    border: none;
  }

  // 弹窗关闭与底部
  .cha_con {
    position: absolute;
    bottom: 8%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 200;
    padding: 8px;
    cursor: pointer;
    .chaImg {
      width: 36px;
      height: 36px;
      pointer-events: auto;
      display: block;
    }
  }
  .logo {
    position: absolute;
    bottom: 4%;
    left: 50%;
    transform: translateX(-50%);
  }

  // 时光/公益专属弹窗内容
  .title_con,
  .title_con1,
  .remark_con,
  .badge_con,
  .dialog_content {
    position: absolute;
    width: 100%;
  }
  .title_con {
    top: 52vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title1 {
      color: #00ff94;
      font-size: 34px;
      font-weight: bold;
      margin-bottom: 16px;
      letter-spacing: 2px;
    }
    .title2 {
      font-size: 28px;
      color: #fff;
      letter-spacing: 1px;
    }
  }
  .title_con1 {
    top: 55vh;
    display: flex;
    align-items: center;
    justify-content: center;
    .img_con {
      width: 33px;
      height: 58px;
    }
    .title_name {
      color: #fff;
      font-weight: 600;
      font-size: 48px;
      min-width: 320px;
      text-align: center;
    }
  }
  .remark_con {
    top: 65vh;
    text-align: center;
    .top_con {
      color: #999;
      font-size: 32px;
      margin-bottom: 10px;
    }
    .buttom_con {
      color: #666;
      font-size: 29px;
    }
  }

  // 徽章轮播
  .badge_con {
    top: 60vh;
    display: flex;
    justify-content: center;
    .imgOne {
      position: absolute;
      left: 50%;
      top: 60.3%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      border-radius: 50%;
      width: 90px;
      height: 90px;
      border: 10px solid #000;
      box-shadow: 0 0 20px rgba(0, 255, 148, 1);
    }
    .name {
      position: absolute;
      bottom: -50px;
      width: 100px;
      font-size: 20px;
      color: #fff;
      text-align: center;
    }
  }

  // 徽章旋转动画
  .dialog_content {
    animation: floatAndFade 1s ease;
    position: absolute;
    top: 15%;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    // 显式层级：大徽章要盖在 info_buttom / badge_con / remark_con 之上，
    // 即使 DOM 顺序调整也不会被遮盖
    z-index: 10;

    .img_con {
      display: flex;
      flex-direction: column;
      align-items: center;
      .badgeImg,
      .badgeImg1,
      .badgeImg2 {
        margin-top: 3vh;
        height: 30vh;
        z-index: 99;
        animation: rotate 2s linear;
        -webkit-user-drag: none;
      }
    }
    @keyframes rotate {
      0% {
        transform: rotateY(0deg);
      }
      100% {
        transform: rotateY(360deg);
      }
    }
  }
}

// 点赞卡列表样式
.tab-con1 {
  .topCon {
    margin-bottom: 10px;
    position: relative;

    img {
      width: 100%;
      height: 148pt;
      object-fit: cover;
    }
    .topTit {
      font-weight: 800;
      font-size: 32px;
      color: #282b32;
      position: absolute;
      top: 7%;
      left: 10%;
    }
    .topDate {
      font-weight: 400;
      font-size: 20px;
      position: absolute;
      top: 25%;
      left: 10%;
      background: linear-gradient(90deg, #d8fd71 0%, #87f6f9 100%);
      color: #357d5c;
      border-radius: 20px;
      padding: 10px 20px;
    }
    .num {
      font-weight: 500;
      font-size: 23px;
      position: absolute;
      top: 5.5%;
      right: 14.4%;
      color: $color-primary;
    }
    .btnCon {
      display: flex;
      justify-content: center;
      position: absolute;
      top: 62%;
      right: 31%;

      ::v-deep .btnOne {
        width: 264px;
        height: 69px;
        border-radius: 30px;
        background: linear-gradient(333deg, #0aad82 0%, #61e69e 100%);
        color: #fff;
        border: 0;
      }
    }
  }
}
</style>
